import makeStyles from "utils/makeStyles";

export default makeStyles((theme) => ({
  header: {
    padding: "10px 20px",
  },
}));
